import { render, staticRenderFns } from "./card-resetpin.vue?vue&type=template&id=450ee96c&"
import script from "./card-resetpin.vue?vue&type=script&lang=js&"
export * from "./card-resetpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports